import type { Campaign } from 'c-sdk';
import { usesInsertionOrderTargeting } from 'c-main/Lib';

type ReportingInputField =
    | 'expected_impacts'
    | 'delivered_value'
    | 'bought_value'
    | 'show_campaign_values_box';

const ALL_FIELDS: ReportingInputField[] = [
    'expected_impacts',
    'delivered_value',
    'bought_value',
    'show_campaign_values_box',
];

/**
 * UL-8133 -- the fields the Reporting Inputs dialog saves.
 *
 * On an insertion-order targeting campaign (`vistar_us2`) Expected Impressions is the sum of the
 * insertion order targets, so it is shown but never sent: the API refuses it with a 422. Every
 * other type saves it as before.
 */
export const reportingInputFields = (
    campaign: Pick<Campaign, 'type'> | null | undefined,
): ReportingInputField[] =>
    usesInsertionOrderTargeting(campaign)
        ? ALL_FIELDS.filter(field => field !== 'expected_impacts')
        : ALL_FIELDS;

/** The dialog's starting values: exactly the fields it may send. */
export const reportingInputDefaults = (campaign: Campaign): Partial<Campaign> =>
    Object.fromEntries(
        reportingInputFields(campaign)
            .filter(field => field in campaign)
            .map(field => [field, campaign[field]]),
    ) as Partial<Campaign>;
